<template>
  <div>
    <form class="form-horizontal">
      <input type="hidden" name="id" id="id"/>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.api_name==''}" style='align:left'>
          <label class="control-label col-sm-3">API名称</label>
          <div class="controls col-sm-8">
              <input type="text" name="api_name" id="api_name" v-model="biz.api_name" class="form-control" />
          </div>
          <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.caller==''}" style='align:left'>
          <label class="control-label col-sm-3">CALLER</label>
          <div class="controls col-sm-8">
              <input type="text" name="caller" id="caller" v-model="biz.caller" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填</span> 
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">是否检查SESSION</label>
          <div class="controls col-sm-8">
              <select class="form-control" v-model="biz.need_check_session">
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
          </div>
          <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">是否检查SIGN</label>
          <div class="controls col-sm-8">
            <select class="form-control" v-model="biz.need_check_sign">
              <option value="1">是</option>
              <option value="0">否</option>
            </select>
          </div>
          <span class="help-inline">必填</span> 
      </div>

      <div class="form-group lp-flex-box" style='align:left'>
        <button class="btn" type="button" @click="close">取消</button>
        <button class="btn green" type="button" @click="save">确定</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../lib/utils/request.js'
import commonMethods from '../../lib/methods/common.js'
import mixins from '../../mixins/index'
import {MSG_ID} from '../../lib/constant.js'
export default {
  name: 'roleedit',
  mixins: mixins,
  data () {
    return {
      biz: {
        id: 0,
        api_name: '',
        caller: '',
        need_check_sign: 0,
        need_check_session: 0,
        items: []
      }
    }
  },
  methods: {
    load () {
      if (this.biz.id) {
        this.loadApiAcs()
      }
    },
    loadApiAcs () {
      if (this.biz.id) {
        http.invoke('auth.pageApiAcs', {account: this.uid(), id: this.biz.id, page_index: 1, page_size: 1}, (data) => {
          let api = data.content && data.content[0]
          if (api) {
            this.biz.id = api.id
            this.biz.api_name = api.api_name
            this.biz.caller = api.caller
            this.biz.need_check_session = api.need_check_session
            this.biz.need_check_sign = api.need_check_sign
          }
        })
      }
    },
    onShowInModal (...args) {
      let options = args[0]
      this.biz.id = +options['id']
      this.load()
    },
    onHideInModal (...args) {
      this.biz.id = 0
      this.biz.api_name = ''
      this.biz.caller = ''
      this.biz.need_check_session = 0
      this.biz.need_check_sign = 0
    },
    save () {
      if (!this.biz.api_name || !this.biz.caller) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '信息不完整')
        return
      }
      let reqdata = {action: 1, api_name: this.biz.api_name, id: this.biz.id, caller: this.biz.caller, need_check_session: this.biz.need_check_session, need_check_sign: this.biz.need_check_sign}
      http.invoke('auth.setApiAcs', reqdata, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_APIACS_SET_SUCCESS)
      })
    },
    close () {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    ...commonMethods
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ApiAcsEdit.vue?edcd4b02